module.exports = __webpack_public_path__ + "img/56212____.prt.77a4641b.jpg";